import { getUserByCert } from './users.js';

/**
 *
 * @param user
 * @returns {`${string} ${string}`}
 * @private
 */
const _genName = (user) => `${ user.firstname } ${ user.lastname }`;

/**
 *
 * @param cert
 * @returns {(function(*): Promise<null|{[p: string]: any}>)|*}
 */
export const getDentalHistoryFilters = (cert) => async (dispatch) => {
    const user = await dispatch(getUserByCert(cert));
    if (user === false) {
        return null;
    }

    const { userID, dependents } = user;
    const memberName = _genName(user);
    const deps = Object.fromEntries(dependents.map((e) => {
        const { dependentID } = e;
        const depName = _genName(e);
        return [ depName, { userID, dependentID }];
    }));
    return {
        All: { userID },
        [memberName]: { userID, dependentID: null },
        ...deps
    };
};